'use client';

import { useSearchParams } from 'next/navigation';

const VALID_CANONICAL_SEARCH_PARAMS = new Set(['tab', 'page']);

interface Props {
  hostName: string;
  locale: string;
  route?: string[];
  defaultCountriesByLanguage?: Record<string, string[]>;
}

const getFullRoute = (locale: string, route: string[] | undefined) => {
  return route ? `/${locale}/${route.join('/')}` : `/${locale}`;
};

const applyDefaultCountry = (locale: string, route: string[] | undefined, defaultCountriesByLanguage: Record<string, string[]>) => {
  const [language, country] = locale.split('-');
  const defaultCountries = defaultCountriesByLanguage[language.toLowerCase()];

  if (!defaultCountries || defaultCountries.length === 0) return getFullRoute(locale, route);

  if (defaultCountries.some((code) => code.toUpperCase() === country.toUpperCase())) return getFullRoute(locale, route);
  return getFullRoute(`${language}-${defaultCountries[0].toUpperCase()}`, route);
};

const Canonical = ({ hostName, locale, route, defaultCountriesByLanguage }: Props) => {
  const searchParams = useSearchParams();

  const canonicalSearchParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    if (VALID_CANONICAL_SEARCH_PARAMS.has(key)) {
      canonicalSearchParams.append(key, value);
    }
  });
  const canonicalQuery = canonicalSearchParams.toString();
  const canonicalPath = defaultCountriesByLanguage ? applyDefaultCountry(locale, route, defaultCountriesByLanguage) : getFullRoute(locale, route);
  const canonical = canonicalQuery ? `${hostName}${canonicalPath}?${canonicalQuery}` : `${hostName}${canonicalPath}`;

  return <link rel="canonical" href={canonical} key="canonical" />;
};

export default Canonical;
